import React from "react";
export default function DefaultResultItem({
	path,
	primary_content_topic: { name: contentTopic = "" } = {},
	summary,
	title,
}) {
  summary = summary.replace('&nbsp;','').replace('&amp;','&');
  title = title.replace('&nbsp;','').replace('&amp;','&');
	return (
		<div className="pb-8 border-b border-gray-400 max-w-2xl">
			{!!contentTopic ? (
				<span className="text-primary text-xs uppercase">{contentTopic}</span>
			) : null}
			{!!title ? (
				<h3>
					<a
						href={path}
						className="block mt-2 mb-4 text-black text-xl no-underline font-bold"
					>
						{title}
					</a>
				</h3>
			) : null}
			{!!summary ? <div className="text-coolGray-400">{summary}</div> : null}
		</div>
	);
}
